import React from "react";
import { Box } from "@mui/material";

const mapStyles = {
  height: "100%",
  position: "relative",
  width: "100%",
};

const Map = React.forwardRef(function Map({ children }, ref) {
  return (
    <Box component="section" sx={{ position: "relative", height: "100%" }}>
      <Box ref={ref} sx={mapStyles} id="public-map" tabIndex="-1" />
      {children}
    </Box>
  );
});

export default Map;
